<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-row class="pb-2">
        <vx-card>
          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
          >
            <h3>{{ campaignDetails['campaign_name'] }}</h3>
          </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="12"
              vs-xs="12"
            >
              <span class="mr-5">Select:</span>

              <v-select
                style="width: 100%"
                v-model="selected_default_view_for_client_user"
                label="name"
                :options="selected_default_view_options"
                name="selected_default_view_for_client_user"
              />
            </vs-col>
           
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-button
                @click="saveDefaultViewPopup"
                color="danger"
                type="border"
                >Save View</vs-button
              >
              
            </vs-col>

            <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-button
              @click="manageDefaultViewPopup"
              color="danger"
              type="border"
              >Manage View</vs-button
            >
            
          </vs-col>
          </vs-row>
        </vx-card>
      </vs-row>

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <vx-card title="Accounts" class="mr-3">
            <div class="agrid-scroll">
              <DataGrid :context="'AccountDataSourceForClientView'" 
                ref="AccountDataSourceForClientView"
                :columnDefs="accountColumnDefs"
                :rowData="accountRecords"
                :dataSource="accountDataSource"
                :rowSelection="'single'"
              >
              </DataGrid>
            </div>
          </vx-card>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <vx-card title="Contacts" class="mr-3">
            <div class="agrid-scroll">
              <DataGrid :context="'ContactDataSourceForClientView'" 
                ref="ContactDataSourceForClientView"
                :columnDefs="contactColumnDefs"
                :rowData="contactRecords"
                :dataSource="contactDataSource"
                :rowSelection="'single'"
              >
              </DataGrid>
            </div>
          </vx-card>
        </vs-col>
      </vs-row>
      <vs-popup
        title="Save Default View"
        fullscreen
        :active.sync="showHidesaveDefaultViewPopup"
      >
        <vs-row vs-w="12">
          <vs-col vs-lg="5" vs-sm="12" vs-xs="12">
            <vs-row>
              <vs-col vs-type="flex" vs-w="12">
                <div class="vx-row w-full mt-5">
                  <div class="vx-col sm:w-1/2 w-full">
                    <h6>Name:</h6>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      v-validate="'required'"
                      class="w-full"
                      v-model="save_view_name"
                      name="name"
                    />

                     <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{
              errors.first("name") }}</span>
                    <!-- <span class="text-danger text-sm">{{
                      please_choose_save_view_name
                    }}</span> -->
                  </div>
                </div>
              </vs-col>

              <vs-col vs-type="flex" vs-w="12">
                <div class="vx-row w-full mt-5">
                  <div class="vx-col sm:w-1/2 w-full">
                    <h6>Description:</h6>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-textarea
                      class="w-full"
                      name="save_view_description"
                      v-model="save_view_description"
                    />
                    <vs-button
                      class="mt-5"
                      @click.prevent="submitClientUserDefaultViewAction"
                      >Submit</vs-button
                    >
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </vs-col>

          <vs-col vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
            <vs-row>
              <vs-col vs-type="flex" vs-w="12">
                <div class="vx-row w-full mt-5">
                  <div class="vx-col sm:w-1/5 w-full"></div>

                  <div class="vx-col sm:w-1/2 w-full">

                    <template v-for="cc in campaign_clients">


                      <h5><u>Client : {{cc['company_name']}}</u></h5> 


                      <vs-col
                      class="p-2"
                      v-for="client_user in client_users"
                      v-if="cc['uuid'] == client_user['client_id']"
                      vs-type="flex"
                      vs-lg="12"
                      vs-sm="12"
                      vs-xs="12"
                    >

                     <template >




                      <input
                        type="checkbox"
                        v-model="save_view_user_id"
                        :value="client_user.uuid"
                      />
                      <h6 class="p-1">{{ client_user.full_name }}</h6>

                     </template>
                     

                    </vs-col>

                    <vs-divider class="m-5" />


                    </template>
                  
                    

                    



                 

                    <!-- <v-select multiple name="save_view_user_id" label="full_name"
                    :options="client_users"
                    v-model="save_view_user_id" data-vv-as="Client User" /> -->
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-lg="3" vs-sm="12" vs-xs="12">
            <vs-row>
              <vs-col vs-type="flex" vs-w="12">
                <div class="vx-row w-full mt-5">
                  <div class="vx-col sm:w-1/5 w-full"></div>

                  <div class="vx-col sm:w-1/2 w-full">
                    <u> <h5 class="p-2">Elomark User:</h5> </u>

                    <vs-col
                      class="p-1"
                      v-for="elomark_user in elomark_users"
                      vs-type="flex"
                      vs-lg="12"
                      vs-sm="12"
                      vs-xs="12"
                    >
                    <template v-if="elomark_user.uuid != user_id">
                      <input 
                      type="checkbox"
                      v-model="save_view_user_id"
                      :value="elomark_user.uuid"
                    />
                    <h6 class="p-1">{{ elomark_user.full_name }}</h6>

                    </template>
                    
                    </vs-col>

                    <!-- <v-select multiple name="save_view_user_id" label="full_name"
                  :options="client_users"
                  v-model="save_view_user_id" data-vv-as="Client User" /> -->
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup
      title="Edit Default View"
      fullscreen
      :active.sync="showHideEditDefaultViewPopup"
    >


      <vs-row vs-w="12">
        <vs-col vs-lg="5" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Name:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    v-model="default_view_edit_details.name"
                    name="name"
                  />
                  

                 
                </div>
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Description:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full"
                    name="save_view_description"
                    v-model="default_view_edit_details.description"
                  />
                  <vs-button
                    class="mt-5"
                    @click.prevent="updateDefaultViewAction"
                    >Submit</vs-button
                  >
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/5 w-full"></div>

                <div class="vx-col sm:w-1/2 w-full">

                  <template v-for="cc in campaign_clients">


                    <h5><u>Client : {{cc['company_name']}}</u></h5> 


                    <vs-col
                    class="p-2"
                    v-for="client_user in client_users"
                    v-if="cc['uuid'] == client_user['client_id']"
                    vs-type="flex"
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                  >

                   <template >




                    <input
                    @click="check($event)"
                      type="checkbox"
                      :value="client_user.uuid"
                      :checked="selected_users_for_edit.includes(client_user.uuid)?'checked':null"
                    />
                    <h6 class="p-1">{{ client_user.full_name }}</h6>

                   </template>
                   

                  </vs-col>

                  <vs-divider class="m-5" />


                  </template>
                
                  

                  



               

                  <!-- <v-select multiple name="save_view_user_id" label="full_name"
                  :options="client_users"
                  v-model="save_view_user_id" data-vv-as="Client User" /> -->
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/5 w-full"></div>

                <div class="vx-col sm:w-1/2 w-full">
                  <u> <h5 class="p-2">Elomark User:</h5> </u>

                  <vs-col
                    class="p-1"
                    v-for="elomark_user in elomark_users"
                    vs-type="flex"
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                  >
                  <template>

                    <input 
                    type="checkbox"
                    @click="check($event)"
                    :checked="selected_users_for_edit.includes(elomark_user.uuid)?'checked':null"
                    :value="elomark_user.uuid"
                  />
                  <h6 class="p-1">{{ elomark_user.full_name }}</h6>

                  </template>
                  
                  </vs-col>

                  <!-- <v-select multiple name="save_view_user_id" label="full_name"
                :options="client_users"
                v-model="save_view_user_id" data-vv-as="Client User" /> -->
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-popup>

      <vs-popup
      title="Default View Detail"
      :active.sync="showHideDefaultViewDetailPopup"
    >
      <vs-row vs-w="12">
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Name:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                 {{ default_view_detail?default_view_detail.name:'' }}
                </div>
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/2 w-full">
                  <h6>Description:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  {{ default_view_detail?default_view_detail.description:'' }}

                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-divider class="m-5" />


        <vs-col vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">




          <vs-row vs-w="12">
            <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
              <template v-for="cc in campaign_clients">


                <strong>  <u>Client : {{cc['company_name']}}</u> </strong>


                <div class="p-2"
                v-for="client_user in client_users"
                v-if="cc['uuid'] == client_user['client_id']"
                vs-type="flex"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >

               <template >




          
                <p class="p-1">{{ client_user.first_name }} {{ client_user.surname }}</p>

               </template>
               

              </div>

              <vs-divider class="m-5" />


              </template>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" vs-xs="12">


               <strong><u>Elomark User: </u></strong> 


                <div
                class="p-1"
                v-for="elomark_user in elomark_users"
                vs-type="flex"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
              <template>

           
                <p class="p-1">{{ elomark_user.first_name }} {{ elomark_user.surname }}</p>

              </template>
              
            </div>



            </vs-col>
  
       
            
          </vs-row>






          
     
        </vs-col>
    
      </vs-row>
    </vs-popup>

      <vs-popup
        title="Manage Default View"
        fullscreen
        :active.sync="showHideManageDefaultViewPopup"
      >
      <DataGrid :context="'defaultViewList'"
      ref="defaultViewList"
      :columnDefs="getDefaultViewColumns"
      :rowData="viewRecords"
      :dataSource="defaultViewDataSource"
      @goToDefaultViewDetails="goToDefaultViewDetails"
      @goToEditDefaultView="goToEditDefaultView"

    >
    </DataGrid>
      </vs-popup>
    </div>
  </div>
</template>

<script>
var revanueValueFormatter = function (params) {
  return params.data.currency_name + ' ' + params.data.revenue
  // return '$' + params.value
}
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import DataGrid from '@/components/aggrid/Aggrid.vue'
import defineAbilitiesFor from '@/config/abilities'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import vSelect from 'vue-select'
import _ from 'lodash'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import moment from 'moment'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
export default {
  data: () => ({
    showHideEditDefaultViewPopup : false,
    showHideDefaultViewDetailPopup : false,
    getDefaultViewColumns: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: 'CellRendererActions',
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 100
      },

      {
        headerName: "Name",
        flex:1,
        field: "name",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          suppressAndOrCondition: false
        }
      },
      {
        headerName: "Description",
        flex:1,
        field: "description",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          suppressAndOrCondition: false
        }
      }
    ],
    viewRecords: [],
    defaultViewDataSource: {},
    campaign_clients: [],
    save_view_user_id: [],
    client_users: [],
    elomark_users: [],
    campaignDetails: [],
    phoneTypes: [],
    selected_sd_account_id: null,
    selected_contact_status: null,
    selected_contact_table_id: null,
    selected_account_status: null,
    selected_account_table_id: null,
    selected_default_view_for_client_user: null,
    selected_default_view_options: [],
    showHidesaveDefaultViewPopup: false,
    showHideManageDefaultViewPopup: false,
    please_choose_save_view_name: null,
    save_view_name: null,
    save_view_description: null,
    showAccountTagFilterOption: false,
    showContactTagFilterOption: false,
    selected_account_contact_status_data: null,
    all_sd_status: [],
    showHideStatusPopUp: false,
    selected_campaign: null,

    user_id: null,
    componentKey: 0,
    abilities: null,
    accountAccountDataSourceForClientViewFields: [
      {
        flex: 1,
        headerName: 'Column',
        field: 'column',
        filter: 'agTextColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          suppressAndOrCondition: false
        }
      },
      {
        flex: 1,

        headerName: 'Value',
        field: 'value',
        filter: 'agTextColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          suppressAndOrCondition: false
        }
      }
    ],
    contactContactDataSourceForClientViewFields: [
      {
        flex: 1,
        headerName: 'Column',
        field: 'column',
        filter: 'agTextColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          suppressAndOrCondition: false
        }
      },
      {
        flex: 1,

        headerName: 'Value',
        field: 'value',
        filter: 'agTextColumnFilter',
        filterParams: {
          buttons: ['apply', 'reset'],
          suppressAndOrCondition: false
        }
      }
    ],
    accountColumnDefs: [],
    campaignFieldsDataSource: {},
    campaignFieldsRecords: [],
    campaignsRecords: [],
    selected_account_id: null,
    contactColumnDefs: [],
    campaignName: null,
    accountDataSource: {},
    campaignId: null,
    abilities: null,
    accountRecords: [],
    contactRecords: [],
    accountAccountDataSourceForClientViewFieldsRecords: [],
    contactContactDataSourceForClientViewFieldsRecords: [],
    selected_contact_id: null,
    contactDataSource: {},
    getSDAccountSelectedDataSource: {},
    getSDContactSelectedDataSource: {},
    contactParamsRequest: {},
    editSelectedAccount: {},
    editSelectedContact: {},
    selectedEditCampaignId: null,
    selectedEditAccountId: null,
    master_field_options: null,
    client_field_options: null,
    campaign_field_options: null,
    master_field_datas: {},
    client_field_datas: {},
    campaign_field_datas: {},
    contact_master_field_datas: {},
    contact_client_field_datas: {},
    contact_campaign_field_datas: {},
    core_field_datas: {},
    showHeadOfficeCountryField: true,
    showHeadOfficeEditAutocomplete: false,
    showRegisteredOfficeCountryField: true,
    showRegisteredOfficeEditAutocomplete: false,
    showRegistrationJurisdictionField: true,
    showRegistrationJurisdictionEditAutocomplete: false,
    showParentField: true,
    showParentEditAutocomplete: false,
    showVerticalField: true,
    showVerticalEditAutocomplete: false,
    showSatelliteOfficeCountryField: true,
    showSatelliteOfficeEditAutocomplete: false,
    roles: [],
    seniorities: [],
    sub_roles: [],
    primary_mobile: null,
    primary_ddi: null,
    dialAction: null,
    optionDescription: [],
    audittrial_action_type_id: null,
    audittrial_outcome_grade: null,
    audittrial_outcome_id: null,
    selected_options: [],
    showSchedulePopUp: false,
    selected_account_contact: null,
    old_master_field_datas: {},
    default_view_detail:{
      name : null,
      description: null,
      checked_user_ids : []
    },
    default_view_edit_details:{
      name : null,
      description: null,
      checked_user_ids : []
    },
    selected_default_view_users : [],
    selected_users_for_edit : []
  }),
  components: {
    'v-select': vSelect,
    DataGrid,
    flatPickr,
    AccountAutocomplete,
    quillEditor
  },
  watch: {
    selected_default_view_for_client_user (val) {
      const account_saved_state = JSON.parse(val.account_view)
      this.$refs.AccountDataSourceForClientView.gridApi.applyColumnState({
        state: account_saved_state,
        applyOrder: true
      })

      const contact_saved_state = JSON.parse(val.contact_view)
      this.$refs.ContactDataSourceForClientView.gridApi.applyColumnState({
        state: contact_saved_state,
        applyOrder: true
      })

      const account_filter_saved_state = JSON.parse(val.account_filter)
      this.$refs.AccountDataSourceForClientView.gridApi.setFilterModel(
        account_filter_saved_state
      )

      const contact_filter_saved_state = JSON.parse(val.contact_filter)
      this.$refs.ContactDataSourceForClientView.gridApi.setFilterModel(
        contact_filter_saved_state
      )
    }
  },
  methods: {
    check(e){
      let self = this
      if(e.target.checked){
        self.selected_users_for_edit.push(e.target.value)
      }else{
        self.selected_users_for_edit = self.selected_users_for_edit.filter(function(item) {
            return item !== e.target.value
        })
      }



      self.selected_users_for_edit = self.selected_users_for_edit.filter((item, i, ar) => ar.indexOf(item) === i);


    },
    goToDefaultViewDetails(data){
      
      this.default_view_detail = data

      this.getDefaultViewSelectedUsers(data.uuid)
      this.showHideDefaultViewDetailPopup = true

      // console.log("sdfsdfsdf" , data)
      //  alert("poeeoeo")
    },
    goToEditDefaultView(data){
      
      this.default_view_edit_details = data
      this.fetchCampaignUsers()
      this.getDefaultViewSelectedUsersForUpdate(data.uuid)
      this.showHideEditDefaultViewPopup = true

      // console.log("sdfsdfsdf" , data)
      //  alert("poeeoeo")
    },

    getDefaultViewSelectedUsersForUpdate (id) {
      let self = this
      let data = {}
      data.view_id = id
      self.$store
        .dispatch('campaignsManagement/getDefaultViewSelectedUsers', data)
        .then(res => {
          if (res) {


            let response_data = res.data

            if(response_data){
              self.selected_default_view_users = JSON.parse(response_data)


              self.selected_default_view_users.forEach(function(ele){
                self.selected_users_for_edit.push(ele.uuid)
              })

              





            }
            


            console.log("SELECTED Users" , self.selected_users_for_edit)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDefaultViewSelectedUsers (id) {
      let self = this
      let data = {}
      data.view_id = id
      self.$store
        .dispatch('campaignsManagement/getDefaultViewSelectedUsers', data)
        .then(res => {
          if (res) {


            self.client_users = []
            self.elomark_users = []

            let response_data = res.data

            if(response_data){
              self.selected_default_view_users = JSON.parse(response_data)


              self.selected_default_view_users.forEach(function (e) {


              if (e.is_client == 'y') {
                self.client_users.push(e)
              } else {
                self.elomark_users.push(e)
              }




              })


              self.client_users = Object.values(self.client_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));


              self.elomark_users = Object.values(self.elomark_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));


            }


            console.log("Users" , self.client_users)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDefaultViewDataSource() {
      var self = this;
      this.defaultViewDataSource = {
        getRows(params) {
          params.request.selected_campaign = self.campaignId

          self.$store
            .dispatch(
              "campaignsManagement/getDefaultViewDataSource",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.defaultViewList.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow });
              } else {
                self.$refs.defaultViewList.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getClientUserDefaultViews () {
      let self = this
      let data = {}
      data.campaign_id = self.campaignId
      data.user_id = self.user_id
      self.$store
        .dispatch('campaignsManagement/getClientUserDefaultViews', data)
        .then(res => {
          if (res) {

            self.selected_default_view_options = JSON.parse(res.data)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    submitClientUserDefaultViewAction () {
      let self = this

      this.$validator.validateAll().then(result => {
        if (result) {


          let data = {}
      data.name = self.save_view_name
      data.description = self.save_view_description
      data.campaign_id = self.campaignId
      self.save_view_user_id.push(self.user_id)

      self.save_view_user_id = self.save_view_user_id.filter(function (
        item,
        pos
      ) {
        return self.save_view_user_id.indexOf(item) == pos
      })

      data.save_view_user_id = self.save_view_user_id
      data.is_default_view = true

      data.account_view =
        this.$refs.AccountDataSourceForClientView.gridApi.getColumnState()
      data.contact_view =
        this.$refs.ContactDataSourceForClientView.gridApi.getColumnState()
      data.account_filter =
        this.$refs.AccountDataSourceForClientView.gridApi.getFilterModel()
      data.contact_filter =
        this.$refs.ContactDataSourceForClientView.gridApi.getFilterModel()
      if (self.save_view_name != null) {
        self.$store
          .dispatch(
            'campaignsManagement/submitClientUserDefaultViewAction',
            data
          )
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                location.reload();

              }else{

                self.$vs.notify({
                color: "danger",
                title: "Default View",
                text: res.data.message
            });
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }



        }

        })


    },
   updateDefaultViewAction () {
      let self = this

    
          self.default_view_edit_details.checked_user_ids = self.selected_users_for_edit

        self.$store
          .dispatch(
            'campaignsManagement/updateDefaultViewAction',
            self.default_view_edit_details
          )
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                location.reload();

              }
            }
          })
          .catch(err => {
            console.log(err)
          })



    },
    saveDefaultViewPopup () {
      this.showHidesaveDefaultViewPopup = true
    },
    manageDefaultViewPopup () {
      this.showHideManageDefaultViewPopup = true
    },

    getAccountDataSourceForClientView () {
      var self = this
      this.accountDataSource = {
        getRows (params) {
          if (!_.isEmpty(params.request.filterModel)) {
            self.contactParamsRequest = {}
          }

          if (!_.isEmpty(self.contactParamsRequest)) {
            params.request.filterModel = Object.assign(
              self.contactParamsRequest.filterModel,
              params.request.filterModel
            )
          }

          if (self.selected_contact_id != null) {
            params.request.selected_contact_id = self.selected_contact_id
          }

          params.request.campaignId = self.$route.params.campaignId
          params.request.userId = self.user_id
          // params.request.campaignName = 'Fishy Campaign';

          self.$store
            .dispatch(
              'accountsManagement/fetchAllAccountDataSourceForClientView',
              params.request
            )
            .then(function (response) {
              let response_data = response.rows

              response_data.forEach(function (ele) {
                if (ele.url) {
                  if (ele.url.length == 0) {
                    ele.url = ''
                  } else if (ele.url.length > 1) {
                    ele.url = 'ΞΞ'
                  } else {
                    ele.url = ele.url[0].url
                  }
                }
              })

              response_data.forEach(function (ele) {
                if (ele.url) {
                  if (ele.url.length == 0) {
                    ele.url = ''
                  } else if (ele.url.length > 1) {
                    ele.url = 'ΞΞ'
                  } else {
                    ele.url = ele.url[0].url
                  }
                }
              })

              response_data.forEach(function (ele) {
                if (ele.phone_no) {
                  if (ele.phone_no.length == 0) {
                    ele.phone_no = ''
                  } else if (ele.phone_no.length > 1) {
                    ele.phone_no = 'ΞΞ'
                  } else {
                    ele.phone_no = ele.phone_no[0].phone_no
                  }
                }
              })

              if (response_data.length != 0) {
                self.$refs.AccountDataSourceForClientView.gridApi.hideOverlay()
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.AccountDataSourceForClientView.gridApi.showNoRowsOverlay()
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err)
            })
        }
      }
    },
    getContactDataSourceForClientView () {
      var self = this
      this.contactDataSource = {
        getRows (params) {
          self.contactParamsRequest = params.request
          params.request.campaignId = self.$route.params.campaignId
          params.request.userId = self.user_id
          // params.request.campaignName = 'Fishy Campaign';
          params.request.selected_account_id = self.selected_account_id

          self.$store
            .dispatch(
              'accountsManagement/fetchAllContactDataSourceForClientView',
              params.request
            )
            .then(function (response) {
              let response_data = response.rows

              response_data.forEach(function (ele) {
                if (ele.contact_ddi) {
                  if (ele.contact_ddi.length == 0) {
                    ele.contact_ddi = ''
                  } else if (ele.contact_ddi.length > 1) {
                    ele.contact_ddi = 'ΞΞ'
                  } else {
                    ele.contact_ddi = ele.contact_ddi[0].ddi
                  }
                }
              })

              response_data.forEach(function (ele) {
                if (ele.contact_mobile) {
                  if (ele.contact_mobile.length == 0) {
                    ele.contact_mobile = ''
                  } else if (ele.contact_mobile.length > 1) {
                    ele.contact_mobile = 'ΞΞ'
                  } else {
                    ele.contact_mobile = ele.contact_mobile[0].mobile
                  }
                }
              })

              response_data.forEach(function (ele) {
                if (ele.contact_social_media) {
                  if (ele.contact_social_media.length == 0) {
                    ele.contact_social_media = ''
                  } else if (ele.contact_social_media.length > 1) {
                    ele.contact_social_media = 'ΞΞ'
                  } else {
                    ele.contact_social_media =
                      ele.contact_social_media[0].social_media
                  }
                }
              })

              response_data.forEach(function (ele) {
                if (ele.contact_email) {
                  if (ele.contact_email.length == 0) {
                    ele.contact_email = ''
                  } else if (ele.contact_email.length > 1) {
                    ele.contact_email = 'ΞΞ'
                  } else {
                    ele.contact_email = ele.contact_email[0].email
                  }
                }
              })

              if (response_data.length != 0) {
                self.$refs.ContactDataSourceForClientView.gridApi.hideOverlay()
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.ContactDataSourceForClientView.gridApi.showNoRowsOverlay()
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err)
            })
        }
      }
    },
    getAccountColumnsForDefaultClientView () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getColumnsForDefaultClientView',
          self.$route.params.campaignId
        )
        .then(res => {
          let result = res.data
          if (result) {
            let account_columns = result['account_fields']
          



            account_columns.forEach(function (ele) {
              ele.headerName = ele.name
              ele.field = ele.column_id
              if (ele.type == "date") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.flex = 1
              ele.filterParams = {
                buttons: ['apply', 'reset'],
                maxNumConditions: 4
              }
            })

        

            let actions = {
              headerName: 'Actions',
              sortable: false,
              field: 'transactions',
              // cellRenderer: 'CellRendererActions',
              suppressHeaderMenuButton: true,
              pinned: true,
              width: 110
            }

            this.accountColumnDefs = account_columns
            this.accountColumnDefs.push(actions)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getContactColumnsForDefaultClientView () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getColumnsForDefaultClientView',
          self.$route.params.campaignId
        )
        .then(res => {
    let result = res.data
    if (result) {
      let contact_columns = result['contact_fields']


      console.log("Contact Columns" , contact_columns)
    



      contact_columns.forEach(function (ele) {
        ele.headerName = ele.name
        ele.field = ele.column_id
        if (ele.type == "date") {
            ele.filter = "agDateColumnFilter";
          } else if (ele.type == "number") {
            ele.filter = "agNumberColumnFilter";
          } else {
            ele.filter = "agTextColumnFilter";
          }



        ele.flex = 1
        ele.filterParams = {
          buttons: ['apply', 'reset'],
          maxNumConditions: 4
        }
      })

  

      let actions = {
        headerName: 'Actions',
        sortable: false,
        field: 'transactions',
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 110
      }

      this.contactColumnDefs = contact_columns
      this.contactColumnDefs.push(actions)
    }
  })
        .catch(err => {
          console.log(err)
        })
    },
    goBack: function () {
      this.$router.go(-1)
    },
    getRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.roles = res.data
          console.log(this.roles)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchCampaignDetails () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDetails = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getCampaignClients() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignClients",
          self.$route.params.campaignId
        )
        .then(response => {
          if (response) {
            self.campaign_clients = JSON.parse(response.data);

            console.log("Campaign client" ,  self.campaign_clients)

           

      

          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    fetchCampaignUsers () {
      let self = this
      const campaignId = self.$route.params.campaignId
      self.client_users = []
      self.elomark_users = []

      self.$store
        .dispatch('campaignsManagement/fetchCampaignUsers', campaignId)
        .then(res => {
          let response_data = res.data
          if (response_data) {
            response_data = JSON.parse(res.data)
          }

          response_data.forEach(function (e) {


            if (e.is_client == 'y') {
              self.client_users.push(e)
            } else {
              self.elomark_users.push(e)
            }




          })

          
          self.client_users = Object.values(self.client_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));


          self.elomark_users = Object.values(self.elomark_users.reduce((acc, obj) => ({ ...acc, [obj.uuid]: obj }), {}));

          // let unique = [...new Set(self.elomark_users.map(item => item.uuid))];


          


             


        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    }
  },
  beforeMount () {
    this.getAccountColumnsForDefaultClientView()
    this.getContactColumnsForDefaultClientView()
    this.getAccountDataSourceForClientView()
    this.getContactDataSourceForClientView()
    this.getDefaultViewDataSource()
  },
  mounted () {
    var self = this
    self.getClientUserDefaultViews()
    self.fetchCampaignDetails()

    self.getCampaignClients()
    self.fetchCampaignUsers()
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })

    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']
    this.user_role = userInfo['userRole']

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }

    this.campaignId = self.$route.params.campaignId
  }
}
</script>
<style scoped>
.audit_trial_style {
  height: 600px;
  overflow-y: scroll;
}

.removeButton {
  cursor: pointer;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.agrid-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 572px;
  padding-right: 15px;
}

.td .vs-table--td {
  width: 100%;
}

.ql-class {
  width: 580px;
}

.vertical-align {
  font-size: 10px;
  display: flex;
  justify-content: center;
  /* align horizontal */
  align-items: center;
  /* align vertical */
  /* width: 800px; */
}
</style>
